<app-doenkids-menu-bar> </app-doenkids-menu-bar>

<div class="page-container">
  <mat-progress-bar *ngIf="!timedOut" mode="indeterminate"></mat-progress-bar>
</div>
